<ion-content [fullscreen]="true" class="page-content" color="light">
  <modal-container class="mentorage-modal" [breadcrumbsList]="breadcrumbsList" [hideSaveButton]="true">
    <monitoring [isDesktop]="true" style="width: 100%; height: 100%;"></monitoring>
  </modal-container>
</ion-content>
